import React, { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import loadercrs from "../assets/images/loadercrs.gif";
import { useLocation } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import REPORT_BASE_URL from "../utilities/ReportConfig";
import dayjs from "dayjs";


const ShyahReport = () => {
  debugger
  const location = useLocation();
  const reportType = location.state?.reportType;
console.log('reportType',reportType)
  const { userDetails } = useSelector((state) => state.auth);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [fromDate, setFromDate] = useState(dayjs());  
  const [toDate, setToDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);



  const handleOkButtonClick = () => {
    let reportUrl = "";
  
    if (reportType === "Main") {
      if (!selectedDate) {
        toast.error("Please select a date");
        return;
      }
  
      const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD"); // Ensure it's a Day.js object
  
      reportUrl = `${REPORT_BASE_URL}/Report/CashReceiptReports_Main.aspx?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&recptdate=${formattedDate}`;
      setSelectedDate(null);
 
    } else {
      if (!fromDate || !toDate) {
        toast.error("Please select both From and To dates");
        return;
      }
  
      const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
      const formattedToDate = dayjs(toDate).format("YYYY-MM-DD");
  
      reportUrl = `${REPORT_BASE_URL}/Report/CashReceiptReports_Copy.aspx?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&vol=${""}&sr=${""}&year=${""}&recptDate=${formattedFromDate}&tdate=${formattedToDate}&mode=${reportType}`;
      setFromDate(null);
      setToDate(null);
 
   
    }
  
    window.open(reportUrl, "_blank");
  };
  
  
  return (
    <>
      {/* Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <img src={loadercrs} alt="Loading..." className="w-48 h-48" />
        </div>
      )}

      <div
        className={`flex h-screen ${
          loading ? "pointer-events-none blur-sm" : ""
        }`}
      >
        <SideMenu />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
            {/* Left Side */}
            <div className="flex-1 p-2 overflow-y-auto">
  <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4"> {reportType} Shyah</h1>
  <div className="max-w-full p-1 rounded-md mx-4">
    {/* Date Inputs */}
    <div className="flex flex-col md:flex-row w-3/4 items-end gap-2">
      {reportType !== "Main" && (
        <>
          <div className="flex-1">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
  label="From Date"
  value={fromDate || null}
  onChange={(newValue) => setFromDate(newValue)}
  slotProps={{ textField: { size: "small" } }}
/>

            </LocalizationProvider>
          </div>
          <div className="flex-1">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate || null}
                onChange={(newValue) => setToDate(newValue)}
                slotProps={{ textField: { size: "small" } }}
              />
            </LocalizationProvider>
          </div>
        </>
      )}

      {reportType === "Main" && (
        <div className="flex items-center gap-2">
          <div className="flex-1">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Selected Date"
                value={selectedDate || null}
                onChange={(newValue) => setSelectedDate(newValue)}
                slotProps={{ textField: { size: "small" } }}
              />
            </LocalizationProvider>
          </div>

        
        </div>
      )}

      <div className="flex">
        <button
          className="bg-blue-500 text-white text-sm px-4 py-3 rounded-md hover:bg-blue-600 focus:outline-none md:ml-2 mt-5 md:mt-1"
          onClick={handleOkButtonClick}
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>


            {/* Right Side */}
            <div className="hidden md:block w-full md:w-64 h-full p-4">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShyahReport;
